import { locationService } from '../services/locationService';

const STATE_NAME_TO_ABBR = Object.fromEntries(
  locationService.getUSStates().map(({ value, label }) => [label.toLowerCase(), value])
);

/** Map topojson state name or 2-letter code to abbreviation used in BCP data. */
export function resolveStateAbbreviation(nameOrCode?: string | null): string | null {
  if (!nameOrCode) return null;
  const trimmed = nameOrCode.trim();
  if (trimmed.length === 2) return trimmed.toUpperCase();
  return STATE_NAME_TO_ABBR[trimmed.toLowerCase()] ?? null;
}
